import { render, staticRenderFns } from "./Initialization.vue?vue&type=template&id=b9417f20&"
import script from "./Initialization.vue?vue&type=script&lang=js&"
export * from "./Initialization.vue?vue&type=script&lang=js&"
import style0 from "./Initialization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports